import { useEffect, useRef } from "react";
import gsap from "gsap";

const MainNavigationDotItem = ({ state }) => {

    const itemRef = useRef(null);

    useEffect(() => {
        const dots = itemRef.current.querySelectorAll('.navigation_dot-item_dot')
        // console.log(dots);
        if (state === 'complete') {
            for (var i = 0; i < dots.length; i++) {
                gsap.killTweensOf(dots[i]);
                gsap.to(dots[i], {
                    duration: 0.1,
                    background: '#24A3F0',
                });
            }
        }
        else if (state === 'active') {
            for (var i = 0; i < dots.length; i++) {
                dots[i].style.background = 'rgba(5, 5, 5, 0.2);'
                gsap.to(dots[i], {
                    delay: i * 0.1,
                    duration: 0.4,
                    repeat: -1,
                    yoyo: true,
                    background: '#24A3F0',
                });
            }
        }

        else {
            for (var i = 0; i < dots.length; i++) {
                gsap.killTweensOf(dots[i]);
                gsap.to(dots[i], {
                    duration: 0.1,
                    background: 'rgba(5, 5, 5, 0.2)'
                });
            }
        }
    }, [state]);

    return (
        <>
            <div
                ref={itemRef}
                className="navigation_dot-item">
                <div className="navigation_dot-item_dot"></div>
                <div className="navigation_dot-item_dot"></div>
                <div className="navigation_dot-item_dot"></div>
                <div className="navigation_dot-item_dot"></div>
                <div className="navigation_dot-item_dot"></div>
                <div className="navigation_dot-item_dot"></div>
                <div className="navigation_dot-item_dot"></div>
                <div className="navigation_dot-item_dot"></div>
            </div>
        </>
    );
};

export default MainNavigationDotItem;